import { ICON_ACCENTS } from '../Chat/EmployeeComputer/AppIcon';

/**
 * The Delegate app's one colour (Nitish, Sep 21 2026: the app colour, its primary and its icon are the same).
 * Grape since Sep 23 2026. Its own module so the agent pages under /delegate/<agent> can wear it without
 * importing the Delegate page itself.
 */
export const DELEGATE_ACCENT = ICON_ACCENTS.grape;

/** The --app-accent pair for surfaces outside AppAccentTheme's DOM scope (a BottomSheet portals to <body>). */
export const delegateAccentVars = (isDarkMode) => ({
  '--app-accent': isDarkMode ? DELEGATE_ACCENT.dark : DELEGATE_ACCENT.light,
  '--app-on-accent': isDarkMode ? '#1d1d1f' : '#ffffff',
});
